/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'getDrawSystemGameTypeResultsByRootId',
    message: messages.SUCCESS_GET_DRAW_SYSTEM_GAME_TYPE_RESULTS_BY_ROOT_ID,
    method: 'GET',
    path: '/draw/:drawId/system-game-type-results/:rootId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_DRAW_SYSTEM_GAME_TYPE_RESULT,
    requestSchema: requestSchemas.drawSystemGameTypeResults.getDrawSystemGameTypeResultsByRootId,
    scopes: [scopes.DEFAULT],
  },
  {
    action: 'printDrawSystemGameTypeResultsByRootId',
    message: messages.SUCCESS_PRINT_DRAW_SYSTEM_GAME_TYPE_RESULTS_BY_ROOT_ID,
    method: 'POST',
    path: '/draw/:drawId/system-game-type-results/:rootId/print',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.PRINT_DRAW_SYSTEM_GAME_TYPE_RESULT,
    requestSchema: requestSchemas.drawSystemGameTypeResults.printDrawSystemGameTypeResultsByRootId,
  },
  {
    action: 'shareDrawSystemGameTypeResultsByRootId',
    message: messages.SUCCESS_SHARE_DRAW_SYSTEM_GAME_TYPE_RESULTS_BY_ROOT_ID,
    method: 'POST',
    path: '/draw/:drawId/system-game-type-results/:rootId/share',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.SHARE_DRAW_SYSTEM_GAME_TYPE_RESULT,
    requestSchema: requestSchemas.drawSystemGameTypeResults.shareDrawSystemGameTypeResultsByRootId,
  },
  {
    action: 'updateDrawSystemGameTypeResultsByRootId',
    message: messages.SUCCESS_UPDATE_DRAW_SYSTEM_GAME_TYPE_RESULTS_BY_ROOT_ID,
    method: 'PATCH',
    path: '/draw/:drawId/system-game-type-results/:rootId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.UPDATE_DRAW_SYSTEM_GAME_TYPE_RESULT,
    requestSchema: requestSchemas.drawSystemGameTypeResults.updateDrawSystemGameTypeResultsByRootId,
  },
];
